export const DAYS_PER_WEEK = 7;
export const QUESTIONS_PER_DAY = 10;
export const WEEKLY_QUESTION_COUNT = DAYS_PER_WEEK * QUESTIONS_PER_DAY;
export const TRIVIA_OFF_QUESTION_COUNT = 10;

export const WEEKLY_DIFFICULTY_PATTERN = [
  "easy",
  "medium",
  "hard",
  "medium",
  "hard",
  "easy",
  "medium",
  "hard",
  "medium",
  "hard"
] as const;
